import { MonitorIndexPage } from "./index";
import { Options } from "vue-class-component";
import components from "../../components/component";
import { Equipment } from "@/modules/maintenance/services";
import { first } from "lodash";
import { CloudMonitorBloc } from "../../services/bloc/bloc.cloud";
import monitorBloc from "../../services/bloc";

@Options({
  components: components,
})
export class CloudMonitorIndexPage extends MonitorIndexPage {
  cloudMonitorBloc: CloudMonitorBloc;

  async created(): Promise<void> {
    this.cloudMonitorBloc = this.monitorBloc as CloudMonitorBloc;
    await this.fetchEquipment();
    await this.getAlarm();
  }

  async fetchMap(equipments: Equipment[]) {
    if (equipments.length < 1) return;
    try {
      const equipment: any = first(equipments);
      const site: any = await this.cloudMonitorBloc.getCloudSite(
        equipment.site.id
      );
      equipment.site = site.data;
      const center = [
        equipment.site.additional.latitude as number,
        equipment.site.additional.longitude as number,
      ];
      this.map = {
        center,
      };
    } catch (e) {}
  }

  async getAlarm() {
    try {
      const userStorage = await this.monitorBloc.getUserStorage();
      const siteStorage = await this.monitorBloc.getSiteStorage();

      this.subscription.alarm = (
        await this.monitorBloc.listenAlarm(userStorage.id, siteStorage.id)
      ).subscribe(async (alarm: any) => {
        if (!alarm) return;
        this.equipments = this.equipments.map((equipment) => {
          return {
            ...equipment,
            sensors: equipment.sensors.map((sensor) => {
              if (sensor.id != alarm.sensor_id) return sensor;
              const isSame = alarm.created_at == sensor.alarm_created_at;
              return {
                ...sensor,
                alarm: isSame ? sensor.alarm : alarm.alarm_popup == "yes",
                message: isSame ? sensor.message : alarm.message,
                alarm_type: isSame ? sensor.alarm_type : alarm.alarm_type,
                alarm_created_at: isSame
                  ? sensor.alarm_created_at
                  : alarm.created_at,
              };
            }),
          };
        });
      });
    } catch (error) {
      console.log(error);
    }
  }
}
